import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";

export default function ColumnistDetail() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  useEffect(() => { api.get(`/columnists/by-slug/${slug}`).then((r) => setC(r.data)); }, [slug]);
  if (!c) return <div className="max-w-3xl mx-auto px-4 py-10">Yükleniyor...</div>;
  return (
    <div className="max-w-3xl mx-auto px-4 py-6">
      <div className="flex items-center gap-4">
        <img src={c.photo} alt={c.name} className="w-24 h-24 rounded-full object-cover" />
        <div>
          <h1 className="text-2xl font-black">{c.name}</h1>
          <p className="text-sm text-gray-600">{c.bio}</p>
          <div className="flex gap-2 mt-2 text-xs">
            {c.social?.twitter && <a href={c.social.twitter} target="_blank" rel="noreferrer" className="text-[#e11d2a]">Twitter</a>}
            {c.social?.instagram && <a href={c.social.instagram} target="_blank" rel="noreferrer" className="text-[#e11d2a]">Instagram</a>}
          </div>
        </div>
      </div>
      <h2 className="text-lg font-bold mt-6 mb-3">Yazılar</h2>
      <div className="space-y-3">
        {(c.columns || []).map((col) => (
          <Link key={col.id} to={`/yazi/${col.slug}`} className="block bg-white border border-gray-100 rounded-lg p-4 hover:border-[#e11d2a]">
            <div className="text-xs text-gray-500 mb-1">{new Date(col.publish_at).toLocaleDateString("tr-TR")}</div>
            <div className="font-bold">{col.title}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
